import { Navigate, useParams } from 'react-router-dom';

import { CaseStudy } from '../../components/portfolio/case-study';
import { productsBySlug } from '../../content';

export const Product = () => {
  const { slug } = useParams();
  const product = slug ? productsBySlug[slug] : undefined;

  if (!product) {
    return <Navigate to="/our-products" replace />;
  }

  return <CaseStudy entry={product} parent={{ name: 'Our products', path: '/our-products' }} />;
};
